<template lang="pug">
    div
        v-row
            v-col.py-2.mb-1(cols='12' sm='6')
                v-btn-toggle(v-model='agentFilterToggle' dense mandatory)
                    v-btn(value="all")
                        span.hidden-sm-and-down All
                    v-btn(value="idle")
                        span.hidden-sm-and-down Idle
                    v-btn(value="working")
                        span.hidden-sm-and-down Working
                    v-btn(value="calls")
                        span.hidden-sm-and-down Calls
                    v-btn(value="inbound_calls")
                        span.hidden-sm-and-down Inbound
                    v-btn(value="outbound_calls")
                        span.hidden-sm-and-down Outbound
                    v-btn(value="emails")
                        span.hidden-sm-and-down Emails
                    v-btn(value="messages")
                        span.hidden-sm-and-down Messages

        v-simple-table.table-x-scroll.sticky-col-inherit-1.sticky-col-inherit-2(v-if="renderAgents && renderAgents.length > 0" style="width: 100%;")
            template(v-slot:default)
                thead
                    tr.volie-background-color-blue
                        th.white--text#column-header-first Team
                        th.white--text(:style="{ left: firstColumnWidth + 'px'}")
                            TableColumnSort(sort-column-name="user_full_name" :selected-sort-column-name="sortByColumnName" :sort-direction="sortByDirection" title="Agent" :on-sort="onSort" color="var(--white)")
                        th.white--text
                            TableColumnSort(sort-column-name="agent_status_name" :selected-sort-column-name="sortByColumnName" :sort-direction="sortByDirection" title="Status" :on-sort="onSort" color="var(--white)")
                        th.white--text
                            TableColumnSort(sort-column-name="time_in_seconds" :selected-sort-column-name="sortByColumnName" :sort-direction="sortByDirection" title="Time" :on-sort="onSort" color="var(--white)")
                        th.white--text
                            TableColumnSort(sort-column-name="inbound_calls_today" :selected-sort-column-name="sortByColumnName" :sort-direction="sortByDirection" title="Inbound Calls" :on-sort="onSort" color="var(--white)")
                        th.white--text
                            TableColumnSort(sort-column-name="outbound_calls_today" :selected-sort-column-name="sortByColumnName" :sort-direction="sortByDirection" title="Outbound Calls" :on-sort="onSort" color="var(--white)")
                        th.white--text
                            TableColumnSort(sort-column-name="appointments_created_today" :selected-sort-column-name="sortByColumnName" :sort-direction="sortByDirection" title="Appointments" :on-sort="onSort" color="var(--white)")
                        th.white--text
                            TableColumnSort(sort-column-name="total_assigned_return_message_campaign_customers" :selected-sort-column-name="sortByColumnName" :sort-direction="sortByDirection" title="Active Conversations" :on-sort="onSort" color="var(--white)")
                        th.white--text
                            TableColumnSort(sort-column-name="unresponded_to_time_in_seconds" :selected-sort-column-name="sortByColumnName" :sort-direction="sortByDirection" title="Longest Waiting" :on-sort="onSort" color="var(--white)")
                        th.white--text Organization
                        th.white--text Campaign
                tbody
                    tr
                        td
                        td
                        td
                        td.text-right Total
                        td {{ summaryRow.inbound_calls_today | number }}
                        td {{ summaryRow.outbound_calls_today | number }}
                        td {{ summaryRow.appointments_created_today | number }}
                        td {{ summaryRow.unresponded_to_time_in_seconds | number }}
                        td
                        td
                        td
                            
                    AgentRow(
                        v-for='agent in renderAgents'
                        :key="agent.account_user_id"
                        :agent="agent"
                        :first-column-width="firstColumnWidth"
                        :teams="teams"
                    )

        v-alert(type="error" v-else dense)
            | Zero agent activity

</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import AgentRow from '@/components/dashboards/live/agents/agent_row.vue';
    import TableColumnSort from "@/components/shared/table_column_sort.vue";

    // Helpers
    import { arraysHaveAtLeastOneCommonElement } from "@/helpers/array";

    export default Vue.extend({
        data() {
            return {
                agentFilterToggle: "working",
                builtRenderAgents: false,
                clockInterval: null,
                firstColumnWidth: 175,
                renderAgents: [],
                sortByColumnName: "user_full_name",
                sortByDirection: "asc",
            }
        },
        methods: {
            agentPassedFilters(agent) {
                // Verify
                if (!agent || !(agent.account_user_id > 0)) {
                    return false;
                }

                // Init
                let statusOk = false;

                // Switch over status type
                switch(agent.agent_status_type) {
                case 0: // inbound
                    if (["all", "calls", "inbound_calls", "working"].indexOf(this.agentFilterToggle) >= 0) {
                        statusOk = true;
                    }
                    break;
                case 1: // outbound
                    if (["all", "calls", "outbound_calls", "working"].indexOf(this.agentFilterToggle) >= 0) {
                        statusOk = true;
                    }
                    break;
                case 4: // non_production
                    if (["all", "idle"].indexOf(this.agentFilterToggle) >= 0) {
                        statusOk = true;
                    }
                    break;
                case 5: // session
                    if (["all"].indexOf(this.agentFilterToggle) >= 0) {
                        statusOk = true;
                    }
                    break;
                case 6: // sms_message
                    if (["all", "messages", "working"].indexOf(this.agentFilterToggle) >= 0) {
                        statusOk = true;
                    }
                    break;
                case 7: // email
                    if (["all", "emails", "working"].indexOf(this.agentFilterToggle) >= 0) {
                        statusOk = true;
                    }
                    break;
                }

                // Verify status result
                if (!statusOk) {
                    return false;
                }

                // Apply team filter
                return this.agentPassedTeamFilter(agent);
            },
            agentPassedTeamFilter(agent) {

                // Verify
                if (!agent) {
                    return false;
                }

                // If valid filter obj, filter accessible
                if (!!this.filterObj) {

                    // Teams
                    if (this.filterObj.teamIds?.length > 0) {

                        // Verify that they share at least one common element
                        if (!(arraysHaveAtLeastOneCommonElement((agent.team_ids || []), this.filterObj.teamIds))) {
                            return false;
                        }
                    }
                }

                return true;
            },
            applyAgentChanges() {

                // If we don't have valid agents or we haven't done the initial build, abort
                if (!this.validAgents || !this.builtRenderAgents) {
                    return;
                }

                // Init
                const accountUserIDsToRemove = [];

                // Loop through agents and apply updates if they meet the criteria
                for (let i = 0; i < this.agents.length; i++) {

                    // Init
                    const propAgent = { ...this.agents[i] };
                    if (!propAgent || !(propAgent.account_user_id > 0)) {
                        continue;
                    }

                    // Verify valid
                    const passedFilters = this.agentPassedFilters(propAgent);

                    // If we have valid render agents, need to loop through and either remove (if passedFilters is false) or apply updates to record
                    if (this.validRenderAgents) {

                        // Init
                        let foundAgent = false;

                        // Loop through render agents
                        for (let j = 0; j < this.renderAgents.length; j++) {

                            // Init - we want the reference to be the same from the array in this case
                            const renderAgent = this.renderAgents[j];
                            if (!renderAgent || !(renderAgent.account_user_id > 0)) {
                                continue;
                            }

                            // Verify that it matches the i record
                            if (propAgent.account_user_id !== renderAgent.account_user_id) {
                                continue;
                            } else {
                                foundAgent = true;
                            }

                            // If filters passed, update values
                            if (passedFilters === true) {

                                // Ensure that the prop agent is fresher than the render agent
                                if (renderAgent.last_agent_id >= propAgent.last_agent_id) {
                                    continue;
                                }

                                // Set values
                                renderAgent.last_agent_id = propAgent.last_agent_id;
                                renderAgent.last_agent_status_id = propAgent.last_agent_status_id;
                                renderAgent.agent_created_at = propAgent.agent_created_at;
                                renderAgent.agent_status_name = propAgent.agent_status_name;
                                renderAgent.agent_status_type = propAgent.agent_status_type;
                                renderAgent.appointments_created_today = propAgent.appointments_created_today;
                                renderAgent.campaign_id = propAgent.campaign_id;
                                renderAgent.campaign_name = propAgent.campaign_name;
                                renderAgent.inbound_calls_today = propAgent.inbound_calls_today;
                                renderAgent.is_online = propAgent.is_online;
                                renderAgent.organization_id = propAgent.organization_id;
                                renderAgent.organization_name = propAgent.organization_name;
                                renderAgent.outbound_calls_today = propAgent.outbound_calls_today;
                                renderAgent.time_in_seconds = null;
                                renderAgent.total_calls = propAgent.total_calls;

                            } else {

                                // Since we found a record in the render and the agent no longer passes the filters, remove from the render slice and 
                                accountUserIDsToRemove.push(renderAgent.account_user_id);
                            }
                        }

                        // If we passed filters but the agent isn't in the render, add them to the filter
                        if (passedFilters === true && !foundAgent) {
                            this.renderAgents.push(propAgent);
                        }

                    } else if (passedFilters === true) { // If no render agents but filters were passed, need to push onto slice
                        this.renderAgents.push(propAgent);
                    }
                }

                // If any account user IDs to remove, do that here
                if (accountUserIDsToRemove.length > 0 && this.validRenderAgents) {

                    // Loop over IDs and remove
                    for (let i = 0; i < accountUserIDsToRemove.length; i++) {
                        this.removeRenderAgent(accountUserIDsToRemove[i]);
                    }
                }

                return this.sortRenderAgents();
            },
            buildRenderAgents() {

                // Reset
                this.renderAgents = [];
                this.builtRenderAgents = false;

                // If we don't have valid agents, abort
                if (!this.validAgents) {
                    return;
                }

                // Init
                const filteredAgents = [];
                const tmpAgents = this.agents.slice();
                if (!(tmpAgents?.length > 0)) {
                    return;
                }

                // Loop through tmp agents and filter based on status
                for (let i = 0; i < tmpAgents.length; i++) {

                    // Init and verify
                    const agent = { ...tmpAgents[i] };
                    if (!agent || !(agent.account_user_id > 0)) {
                        continue;
                    }

                    // Verify passes filter
                    if (!this.agentPassedFilters(agent)) {
                        continue;
                    }

                    // Push onto array
                    filteredAgents.push(agent);
                }

                // If filtered agents is empty, abort
                if (!(filteredAgents.length > 0)) {
                    return;
                }

                // Set
                this.renderAgents = filteredAgents;

                // Sort
                this.sortRenderAgents();

                // Mark as built
                this.builtRenderAgents = true;
            },
            handleSecondColumnStickyPosition() {
                this.firstColumnWidth = document?.getElementById('column-header-first')?.getBoundingClientRect()?.width
            },
            onSort(columnName) {
                if (columnName === this.sortByColumnName) {
                    this.sortByDirection = this.sortByDirection === "asc" ? "desc" : "asc";
                } else {
                    this.sortByColumnName = columnName;

                    switch(columnName) {
                    case "appointments_created_today":
                        this.sortByDirection = "desc";
                        break;
                    case "inbound_calls_today":
                        this.sortByDirection = "desc";
                        break;
                    case "outbound_calls_today":
                        this.sortByDirection = "desc";
                        break;
                    case "time_in_seconds":
                        this.sortByDirection = "desc";
                        break;
                    case "total_assigned_return_message_campaign_customers":
                        this.sortByDirection = "desc";
                        break;
                    case "unresponded_to_time_in_seconds":
                        this.sortByDirection = "desc";
                        break;
                    default:
                        this.sortByDirection = "asc";
                        break;
                    }
                }

                this.buildRenderAgents();
                return;
            },
            removeRenderAgent(accountUserID) {

                // Verify
                if (!accountUserID || !this.validRenderAgents) {
                    return;
                }

                // Find agent via account user ID
                const idx = this.renderAgents.findIndex(i => i.account_user_id === accountUserID);
                if (idx < 0) {
                    return;
                }

                // Remove
                this.renderAgents.splice(idx, 1);
            },
            setClockValues() {

                // Verify render agents
                if (!(this.renderAgents?.length > 0)) {
                    return;
                }
                
                // Init
                const currentTime = new Date();

                // Loop through agents and set time in seconds
                for (let i = 0; i < this.renderAgents.length; i++) {

                    // Init agent
                    const agent = this.renderAgents[i];
                    if (!agent || !agent.agent_created_at) {
                        continue;
                    }

                    // Init agent time
                    const agentTime = new Date(agent.agent_created_at);

                    // Calculate clock
                    agent.time_in_seconds = (Math.floor(currentTime.getTime() - agentTime.getTime()) / 1000);

                    // Handle unresponded to time - this may very well be null if the agent isn't on sms screen or if they are waiting for responses
                    if (!!agent.unresponded_to_incoming_message_at) {

                        // Init time
                        const unrespondedToTime = new Date(agent.unresponded_to_incoming_message_at);
                        if (!!unrespondedToTime) {

                            // Calculate clock
                            agent.unresponded_to_time_in_seconds = (Math.floor(currentTime.getTime() - unrespondedToTime.getTime()) / 1000);
                        }

                    } else {
                        agent.unresponded_to_time_in_seconds = null;
                    }
                }
            },
            sortAgents(agents, sortByColumnName, sortByDirection) {
                if (!(!!agents && agents.length > 0)) {
                    return [];
                }

                return agents.sort(function(x, y) {

                    // Switch over sort by
                    switch(sortByColumnName) {
                    case "agent_status_name":
                        if (sortByDirection === "desc") {
                            return (y?.agent_status_name || "").localeCompare(x?.agent_status_name || "");
                        } else {
                            return (x?.agent_status_name || "").localeCompare(y?.agent_status_name || "");
                        }
                    case "appointments_created_today":
                        if (sortByDirection === "desc") {
                            return y?.appointments_created_today - x?.appointments_created_today;
                        } else {
                            return x?.appointments_created_today - y?.appointments_created_today;
                        }
                    case "inbound_calls_today":
                        if (sortByDirection === "desc") {
                            return y?.inbound_calls_today - x?.inbound_calls_today;
                        } else {
                            return x?.inbound_calls_today - y?.inbound_calls_today;
                        }
                    case "outbound_calls_today":
                        if (sortByDirection === "desc") {
                            return y?.outbound_calls_today - x?.outbound_calls_today;
                        } else {
                            return x?.outbound_calls_today - y?.outbound_calls_today;
                        }
                    case "time_in_seconds":
                        
                        // Null handle
                        if (x?.agent_created_at === null) {
                            return 1;
                        }
                        if (y?.agent_created_at === null) {
                            return -1;
                        }

                        if (sortByDirection === "desc") {
                            return (new Date(x.agent_created_at)).getTime() - (new Date(y.agent_created_at)).getTime();
                        } else {
                            return (new Date(y.agent_created_at)).getTime() - (new Date(x.agent_created_at)).getTime();
                        }
                    case "total_assigned_return_message_campaign_customers":
                        if (sortByDirection === "desc") {
                            return (y?.total_assigned_return_message_campaign_customers || 0) - (x?.total_assigned_return_message_campaign_customers || 0);
                        } else {
                            return (x?.total_assigned_return_message_campaign_customers || 0) - (y?.total_assigned_return_message_campaign_customers || 0);
                        }
                    case "unresponded_to_time_in_seconds":

                        // Null handle
                        if (x?.unresponded_to_incoming_message_at === null) {
                            return 1;
                        }
                        if (y?.unresponded_to_incoming_message_at === null) {
                            return -1;
                        }

                        if (sortByDirection === "desc") {
                            return (new Date(x.unresponded_to_incoming_message_at)).getTime() - (new Date(y.unresponded_to_incoming_message_at)).getTime();
                        } else {
                            return (new Date(y.unresponded_to_incoming_message_at)).getTime() - (new Date(x.unresponded_to_incoming_message_at)).getTime();
                        }
                    case "user_full_name":
                        if (sortByDirection === "desc") {
                            return (y?.user_full_name || "").localeCompare(x?.user_full_name || "");
                        } else {
                            return (x?.user_full_name || "").localeCompare(y?.user_full_name || "");
                        }
                    default:
                        return (x?.user_full_name || "").localeCompare(y?.user_full_name || "");
                    }
                });
            },
            sortRenderAgents() {

                // Verify
                if (!this.validRenderAgents) {
                    return;
                }

                // First sort by user name always
                this.renderAgents = this.sortAgents(this.renderAgents, 'user_full_name', (this.sortByColumnName === 'user_full_name' ? this.sortByDirection : 'asc'));

                // Now if the sort column is not user name, sort again
                // We do it like this so that on the secondary sort the users are still in alphabetical order
                if (this.sortByColumnName !== "user_full_name") {
                    this.renderAgents = this.sortAgents(this.renderAgents, this.sortByColumnName, this.sortByDirection);
                }
            },
            startClock() {
                this.clockInterval = setInterval(this.setClockValues, 1000);
            },
            stopClock() {
                if (!this.clockInterval) {
                    return;
                }

                clearInterval(this.clockInterval);
            },
        },
        computed: {
            summaryRow() {
                const summary = {
                    inbound_calls_today: 0,
                    outbound_calls_today: 0,
                    appointments_created_today: 0,
                    total_assigned_return_message_campaign_customers: 0,
                }

                // Loop over all agents (ignoring the status tab) so the totals reflect the full
                // day's activity and don't jump as agents move in and out of the active status filter
                if (this.validAgents) {

                    // Loop over
                    for (let i = 0; i < this.agents?.length; i++) {

                        // Init
                        const agent = this.agents[i];
                        if (!agent || !(agent.account_user_id > 0)) {
                            continue;
                        }

                        // Respect the team filter only
                        if (!this.agentPassedTeamFilter(agent)) {
                            continue;
                        }

                        // Increment
                        summary.inbound_calls_today += (agent.inbound_calls_today || 0);
                        summary.outbound_calls_today += (agent.outbound_calls_today || 0);
                        summary.appointments_created_today += (agent.appointments_created_today || 0);
                        summary.total_assigned_return_message_campaign_customers += (agent.total_assigned_return_message_campaign_customers || 0);
                    }
                }

                return summary;
            },
            validAgents() {
                return this.agents?.length > 0;
            },
            validRenderAgents() {
                return this.renderAgents?.length > 0;
            },
        },
        components: {
            AgentRow,
            TableColumnSort,
        },
        props: {
            agents: Array,
            filterObj: Object,
            teams: Array,
        },
        watch: {
            agents: {
                deep: true, // This will let Vue know to look inside the array
                handler(newAgents, oldAgents) {

                    // Then on next tick, apply changes to rendered agents
                    Vue.nextTick(() => {

                        if (!this.builtRenderAgents) {
                            return this.buildRenderAgents();
                        }

                        const agentIdsKey = (list) => (list || []).map(a => a.account_user_id).sort((a, b) => a - b).join(',');
                        if (agentIdsKey(newAgents) !== agentIdsKey(oldAgents)) {
                            return this.buildRenderAgents();
                        }

                        return this.applyAgentChanges();
                    });
                },
            },
            "agentFilterToggle"() {
                Vue.nextTick(() => { this.buildRenderAgents(); });
            },
            filterObj: {
                deep: true, // This will let Vue know to look inside the array
                handler() {

                    // Then on next tick, apply changes to rendered agents
                    Vue.nextTick(() => {

                        // If we have not built records initially, do that. Otherwise just apply changes
                        return this.builtRenderAgents ? this.applyAgentChanges() : this.buildRenderAgents();
                    });
                },
            },
            renderAgents: {
                handler() {
                    Vue.nextTick(() => { this.handleSecondColumnStickyPosition(); });
                },
                deep: true,
            },
        },
        destroyed() {
            this.stopClock();
            window.removeEventListener('resize', this.handleSecondColumnStickyPosition);
        },
        created() {
            this.startClock();
            window.addEventListener('resize', this.handleSecondColumnStickyPosition);
            this.buildRenderAgents();
        },
        mounted() {
            setTimeout(() => {
                this.handleSecondColumnStickyPosition();
            }, 500);
        },
    });
</script>

<style lang="scss" scoped>
</style>